import { Add } from "@mui/icons-material";
import { LinearProgress, Typography } from "@mui/material";
import CommandBar from "components/disw/CommandBar";
import CommandBarButton from "components/disw/CommandBarButton";
import CommandBarContainer from "components/disw/CommandBarContainer";
import {
  RestrictedSolutionRealm,
  SolutionPermission
} from "features/access-management";
import React from "react";
import { useHistory } from "react-router-dom";
import { createRoute } from "utils/url";
import { useServiceProducts } from "../hooks/useServiceProductsHooks";
import ServiceProductList from "./ServiceProductList";

interface ServiceProductDesignerProps {
  solutionKey: string;
}

const ServiceProductDesigner: React.FC<ServiceProductDesignerProps> = ({
  solutionKey
}) => {
  const history = useHistory();
  const { loading, error, serviceProducts } = useServiceProducts(solutionKey);

  const handleAddClick = () => {
    history.push(
      createRoute(`/solutions/${solutionKey}/service-products/create`)
    );
  };

  const handleCardClick = (productId: string) => {
    history.push(
      createRoute(
        `/solutions/${solutionKey}/service-products/product/${productId}`
      )
    );
  };

  if (loading) return <LinearProgress />;
  if (error || !serviceProducts) {
    return (
      <Typography color="error">
        Error loading service products. {error?.message ?? "Unspecified error."}
      </Typography>
    );
  }

  return (
    <CommandBarContainer
      main={
        <ServiceProductList
          serviceProducts={serviceProducts}
          onClick={handleCardClick}
        />
      }
      sidebar={
        <CommandBar>
          <RestrictedSolutionRealm
            silent
            requiredPermissions={[
              SolutionPermission.ChangeServiceProducts,
              SolutionPermission.ReadWebServices
            ]}
          >
            {({ accessGranted, missingPermissions }) => (
              <CommandBarButton
                icon={<Add />}
                label="Add"
                tooltip={
                  accessGranted
                    ? undefined
                    : `Missing permissions: ${missingPermissions?.join(", ")}`
                }
                disabled={!accessGranted}
                onClick={handleAddClick}
              />
            )}
          </RestrictedSolutionRealm>
        </CommandBar>
      }
    />
  );
};

export default ServiceProductDesigner;
